import Box from '@mui/material/Box';

import { DynamicFieldResponse } from '../../../../../interfaces/DynamicFieldResponse';
import GeneratedFields from '../../../../common/finalReport/GeneratedFields';

interface ViewReportFieldsProps {
  customValues: DynamicFieldResponse[];
}

const DynamicDetails = ({ customValues }: ViewReportFieldsProps) => {
  return (
    <Box>
      <GeneratedFields customValues={customValues} />
    </Box>
  );
};

export default DynamicDetails;
